export { Regist } from './Regist';
